/**
 * <nocturne-topbar> — the Nocturne top bar (sections/nocturne-topbar.liquid): shows one message at a
 * time and fades to the next every data-speed seconds. Rotation pauses while the bar is hovered or
 * focused and stops for visitors who ask for reduced motion; the arrows step back and forth.
 */
(() => {
  if (customElements.get('nocturne-topbar')) return;

  class NocturneTopbar extends HTMLElement {
    connectedCallback() {
      this.msgs = [...this.querySelectorAll('[data-msg]')];
      if (!this.msgs.length) return;
      this.i = 0;
      this.show(0);
      if (this.msgs.length < 2) return;

      this.querySelector('[data-prev]')?.addEventListener('click', () => this.step(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.step(1));
      const pause = () => (this.paused = true);
      const resume = () => (this.paused = this.matches(':hover') || this.contains(document.activeElement));
      this.addEventListener('pointerenter', pause);
      this.addEventListener('pointerleave', resume);
      this.addEventListener('focusin', pause);
      this.addEventListener('focusout', () => setTimeout(resume, 0));

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) this.start();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    step(d, auto = false) {
      this.show((this.i + d + this.msgs.length) % this.msgs.length);
      // A manual step restarts the count, so the chosen message stays a full turn.
      if (!auto && this.timer) {
        clearInterval(this.timer);
        this.start();
      }
    }

    start() {
      const every = (parseFloat(this.dataset.speed) || 5) * 1000;
      this.timer = setInterval(() => {
        if (!this.paused && !document.hidden) this.step(1, true);
      }, every);
    }

    show(i) {
      this.i = i;
      this.msgs.forEach((m, k) => {
        m.classList.toggle('is-on', k === i);
        m.inert = k !== i;
      });
    }
  }

  customElements.define('nocturne-topbar', NocturneTopbar);
})();
